// *** MEDICATION SERVICE ***

import { i18n } from '@/main';

// *** GET MEDICATION DISPLAY AMOUNT ***
// Used to display medication amount in the specified format.
export const getMedDisplayAmount = (
    packagesInput,
    extraMedsInput,
    parentheses = false,
    units = null,
    showDirection = false
) => {
    let packages = typeof packagesInput === 'string' ? parseInt(packagesInput) || 0 : packagesInput;
    let extraMeds = typeof extraMedsInput === 'string' ? parseInt(extraMedsInput) || 0 : extraMedsInput;
    packages = Math.abs(packages);
    extraMeds = Math.abs(extraMeds);
    let displayAmount = units
        ? `${packages}\xa0${i18n.t(packages === 1 ? `package_${units}` : `packages_${units}_singular_partitive`)}`
        : packages;
    if (extraMeds && extraMeds > 0) {
        const extraMedsString = units
            ? `${extraMeds}\xa0${i18n.t(extraMeds === 1 ? `piece_${units}` : `pieces_${units}_singular_partitive`)}`
            : extraMeds;
        displayAmount = `${displayAmount}\xa0${parentheses ? '(' : ''}+\xa0${extraMedsString}${parentheses ? ')' : ''}`;
    }
    return showDirection ? `${displayAmount} ${packagesInput < 0 || extraMedsInput < 0 ? '↓' : '↑'}` : displayAmount;
};

// *** GET MEDICATION DISPLAY NAME ***
// Used to display the medication name in the specified format.
export const getMedDisplayName = (med, includeVnr = true, short = false) => {
    let displayName = '';
    if (short) {
        displayName = `${med.name || ''} ${med.dosage || ''} ${med.package_size || ''} ${med.form ||
            ''} ${med.dosage_form || ''}`;
    } else {
        displayName = `${med.name || ''} ${med.company || ''} ${med.dosage || ''} ${med.package_size ||
            ''} ${med.form || ''} ${med.dosage_form || ''}`;
    }
    displayName = displayName.replace(/( )+/g, ' ');
    return includeVnr ? `${med.vnr} ${displayName}` : displayName;
};
